export default {
  allMedia: [],

  lastMedia: [],
  videoLastMedia: [],
  audioLastMedia: [],
  picLastMedia: [],

  chooseMedia: [],

  moreMedia: [],

  tabItems: [],

  moreViewMedia: [],

  similarMedia: [],

  oneMedia: {},

  comments: [],
  commentsTotal: [],

  likes: false,

  report: [],

  audioBannerRight: [],
  audioBannerLeft: [],
};
